import React from "react"

export default class GagVideo extends React.Component {
    render() {
        return <video
                controls={true}
            >
                <source
                    src={process.env.REACT_APP_API_URL + '/api/gagmedia_file_content/' + this.props.gag.id}
                />
            </video>
    }
}
